import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {InputText} from '@/components/commons/input-text/InputText'
import {InputDate} from '@/components/commons/input-date/InputDate'
import {useTranslation} from '@/translations/i18n'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {z} from 'zod'
import {Controller, useFormContext} from 'react-hook-form'
import {MedicalReportUploadDocumentField} from './MedicalReportUploadDocumentField'

const DocumentSchema = MedicalReportFieldsSchema.pick({
    documentTitle: true,
    documentDate: true,
    documentAttachment: true,
    notes: true
})
export type DocumentSchema = z.infer<typeof DocumentSchema>

export const UploadDocumentSectionFields = () => {
    const form = useFormContext<DocumentSchema>()
    const {t} = useTranslation()

    return (
        <Grid columns={2} rowGap={6} columnGap={4} fullWidth>
            <GridItem spanColumn={2}>
                <InputText
                    label={t('medical_records:document_title')}
                    type="text"
                    placeholder={t('medical_records:document_title_placeholder')}
                    width={'60%'}
                    errorMessage={form.formState.errors.documentTitle?.message}
                    {...form.register('documentTitle')}
                />
            </GridItem>
            <Controller
                control={form.control}
                name="documentDate"
                render={({field, fieldState}) => (
                    <InputDate
                        label={t('commons:date')}
                        placeholder={'GG/MM/AAAA'}
                        name="documentDate"
                        fullWidth
                        errorMessage={fieldState.error?.message}
                        value={field.value}
                        onChange={field.onChange}
                    />
                )}
            />

            <MedicalReportUploadDocumentField />
        </Grid>
    )
}
